import { Spinner } from 'react-bootstrap';

function CentredSpinner() {

    return (
        <div className="d-flex justify-content-center">
            <Spinner animation="border" />
        </div>
    );
}

export default CentredSpinner;